<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">项目管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="项目名称">
            <el-input v-model="ProjectName" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="项目状态">
            <el-select v-model="ProjectStatus" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in ProjectStatusList"
                :key="item.value"
                :label="item.lable"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="ProjectName" label="项目名称"></el-table-column>
              <el-table-column prop="ProjectStatus" label="项目状态" :formatter="formatStatus"></el-table-column>
              <el-table-column prop="ProjectProgress" label="项目进度"></el-table-column>
              <el-table-column prop="ProjectCharger" label="负责人"></el-table-column>
              <el-table-column prop="ProjectOrg" label="所属部门"></el-table-column>
              <el-table-column prop="ProjectStartTime" label="计划开始时间" :formatter="formatDate"></el-table-column>
              <el-table-column prop="ProjectEndTime" label="计划结束时间" :formatter="formatDate"></el-table-column>
              <el-table-column prop="CreateTime" label="创建日期" :formatter="formatDate"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="TaskManage(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >任务管理</el-button>
                  <el-button
                    @click="EditDetail(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ProjectManagement",
  controller: "UI",
  action: "ProjectManagement",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      ProjectName: "",
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      ProjectStatus: "",
      ProjectStatusList: [
        { lable: "编辑中", value: 1 },
        { lable: "进行中", value: 2 },
        { lable: "已归档", value: 3 },
        { lable: "已延期", value: 4 },
        { lable: "已停止", value: 5 },
      ],
    };
  },
  created: function () {
    this.search();
  },
  mounted: function () {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.ProjectName = "";
      this.ProjectStatus = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    search() {
      let searchinfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      if (this.ProjectStatus) {
        searchinfo.ProjectStatus = parseInt(this.ProjectStatus);
      }
      if (this.ProjectName && this.ProjectName != "") {
        searchinfo.ProjectName = this.ProjectName;
      }
      this.loadingText = "加载中...";
      this.loading = true;
      new MyApis.ProjectBasicinfoApi()
        .GetPageContentByConditions(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.ContentList;
          this.total = r.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onAdd() {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/ProjectInfo",
        query: {
          type: "add",
        },
      });
    },
    EditDetail(index, row) {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/ProjectInfo",
        query: {
          module: row.ProjectName,
          InfoId: row.ID,
          type: "edit",
          ProjectStatus:row.ProjectStatus
        },
      });
    },
    TaskManage(index, row) {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/ProjectTaskManagement",
        query: {
          InfoId: row.ID,
          ProjectName: row.ProjectName,
          ProjectStatus:row.ProjectStatus
        },
      });
    },
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.ProjectBasicinfoApi()
          .DelItem(row)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },

    formatStatus(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      var result = "";
      this.ProjectStatusList.forEach((item) => {
        if (item.value == data) {
          result = item.lable;
        }
      });
      return result;
    },
  },
};
</script>